import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";
import {filter, map, mergeMap} from "rxjs";
import {environment} from "./environments/environment.production";
import {setCanonicalUrl, setSocialMeta} from "./services/util/util";
import {FBQ} from "./models/fbq";
import {AnalyticsService} from "./services/util/analytics.service";

declare let fbq: FBQ;

/** Pages with nothing for a searcher - kept out of Google so they do not compete with the shop. */
const NOINDEX_PATHS = ['/cart', '/checkout', '/profile', '/admin-panel', '/404', '/403', '/uspesna-naracka'];

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: Title,
        private metaService: Meta,
        private analytics: AnalyticsService
    ) {
    }

    ngOnInit() {
        this.analytics.init();
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.activatedRoute.root),
            map(route => {
                while (route.firstChild) route = route.firstChild;
                return route;
            }),
            mergeMap(route => route.data)
        ).subscribe(data => {
            fbq('track', 'PageView');
            // Product and blog pages set their title once the API answers - give them a moment.
            setTimeout(() => this.analytics.pageView(document.title), 1000);
            const title = data['title'] || 'Алое вера гел - Природна нега со алое вера гел и производи за здравје и убавина!';
            const description = data['metaDescription'] || 'Алое вера гел – Специјализирани алое вера производи за природна нега на тело и лице, контрола на тежина и здрав живот. Откријте висококвалитетни алое вера гелови и производи со природни состојки за секојдневна убавина и здравје.';
            this.titleService.setTitle(title);
            this.metaService.updateTag({name: 'description', content: description});

            // Product and blog pages have no canonicalUrl in their route data - they set their own
            // canonical once the content loads. Writing "https://aloeveragel.mkundefined" here
            // first would hand Google a broken canonical if it snapshots the page early.
            this.metaService.updateTag({
                name: 'robots',
                content: NOINDEX_PATHS.includes(data['canonicalUrl']) ? 'noindex, follow' : 'index, follow'
            });

            if (data['canonicalUrl'] !== undefined) {
                const canonicalUrl = environment.domain.frontend + data['canonicalUrl'];
                setCanonicalUrl(canonicalUrl);
                setSocialMeta(this.metaService, {
                    title,
                    description,
                    url: canonicalUrl,
                    image: environment.domain.frontend + '/assets/logo/logo.png'
                });
            }
        });
    }
}